import { createRouter, createWebHistory } from "vue-router";

import CargoIndex from "@/views/cargo/index.vue";
import CargoShow from "@/views/cargo/show.vue";
import Load from "@/views/Load.vue";
import Support from "@/views/Support.vue";
import Faq from "@/views/faq.vue";
import Feedback from "@/views/Feedback.vue";
import FeedbackFollow from "@/views/FeedbackFollow.vue";
import Service from "@/views/Service.vue";
import MyCargos from "@/views/myCargo/index.vue";
import Inquiry from "@/views/inquiry/index.vue";
import Transaction from "@/views/transaction/index.vue";
import NearLoads from "@/views/nearLoads/index.vue";
import SelectCities from "@/views/provinceLoads/index.vue";
import SearchSelectCities from "@/views/provinceLoads/show.vue";
import Setting from "@/views/setting/index.vue";
import Profile from "@/views/profile/Index.vue";
import ProfileEdit from "@/views/profile/Edit.vue";
import Login from "@/views/authentication/login";
import Verify from "@/views/authentication/verify";
import Register from "@/views/authentication/register";
import TermConditions from "@/views/TermConditions";
import ReturnLoads from "@/views/cargo/components/ReturnLoads.vue";
import Locate from "@/views/Locate.vue";
import Inquery from "@/views/inquery/index.vue";
import Notification from "@/views/notification/index.vue";
import Aware from "@/views/aware/index.vue";
import Home from "@/views/Home.vue";


const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/newCargos",
    name: "newLoads",
    component: CargoIndex,
    meta: { requiresAuth: true },
  },
  
  {
    path: "/inqueries",
    name: "inqueries",
    component: Inquery,
    meta: { requiresAuth: true },
  },
  {
    path: "/nearLoads",
    name: "nearLoads",
    component: NearLoads,
    meta: { requiresAuth: true },
  },
  {
    path: "/inquiry",
    name: "inquiry",
    component: Inquiry,
    meta: { requiresAuth: true },
  },
  {
    path: "/notification",
    name: "notification",
    component: Notification,
    meta: { requiresAuth: true },
  },
  {
    path: "/aware",
    name: "aware",
    component: Aware,
    meta: { requiresAuth: true },
  },
  {
    path: "/transaction",
    name: "transaction",
    component: Transaction,
    meta: { requiresAuth: true },
  },
  {
    path: "/selectCities",
    name: "selectCities",
    component: SelectCities,
    meta: { requiresAuth: true },
  },
  {
    path: "/SearchSelectCities",
    name: "searchSelectCities",
    component: SearchSelectCities,
    meta: { requiresAuth: true },
  },
  {
    path: "/:load",
    name: "cargoShow",
    component: CargoShow,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/returnLoads/:city",
    name: "returnLoads",
    component: ReturnLoads,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/support",
    name: "support",
    component: Support,
    meta: { requiresAuth: true },
  },
  {
    path: "/load",
    name: "load",
    component: Load,
    meta: { requiresAuth: true },
  },
  {
    path: "/locate",
    name: "locate",
    component: Locate,
    meta: { requiresAuth: true },
  },
  {
    path: "/faq",
    name: "faq",
    component: Faq,
    meta: { requiresAuth: true },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: Feedback,
    meta: { requiresAuth: true },
  },
  {
    path: "/feedbackFollow",
    name: "feedbackFollow",
    component: FeedbackFollow,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/profileEdit",
    name: "profileEdit",
    component: ProfileEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: { requiresAuth: true },
  },
  {
    path: "/services",
    name: "service",
    component: Service,
    meta: { requiresAuth: true },
  },
  {
    path: "/myCargos",
    name: "myCargos",
    component: MyCargos,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/callHistory",
  //   name: "callHistory",
  //   component: CallHistory,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/verify/:mobileNumber",
    name: "verify",
    component: Verify,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: "/register/:mobileNumber",
    name: "register",
    component: Register,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: "/terms-and-conditions",
    name: "term",
    component: TermConditions,
    // meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !localStorage.getItem("token")) {
    return { name: "login" };
  }
  if (to.meta.requiresAuth == false && localStorage.getItem("token")) {
    return { name: "home" };
  }
});

export default router;
